import { useQuery } from "@tanstack/react-query";
import userService from "../services";
import { SortField } from "../../../utils/schema/SortType";
import qs from "qs";
import { ExhibitorFilter } from "../../../utils/schema/ExhibitorFilter";

interface useUsersParams {
  sortFields?: SortField[];
  page?: number;
  rowsPerPage?: number;
  filters?: ExhibitorFilter;
  searchText?: string;
  unmappedOnly?: boolean; 

}

export const useUsers = ({
  sortFields,
  page=1,
  rowsPerPage=10,
  filters,
  searchText,
  unmappedOnly = false,
}: useUsersParams = {}) => {
  const sortParam = sortFields
  ? sortFields.map(({ field, order }) => `${field}:${order}`)
  : undefined;

  const query = qs.stringify(
    {
      sort: sortParam,
      start: (page - 1) * rowsPerPage,
      limit: rowsPerPage,
       filters: {
        ...(filters ?? {}),
        ...(searchText
          ? {
              username: {
                $contains: searchText,
              },
            }
          : {}),
        ...(unmappedOnly
          ? {
              exhibitors: {
                id: { $null: true },
              },
            }
          : {}),
      },
        populate: "*",
    },
    { encodeValuesOnly: true }
  );
  const usersData = useQuery({
    queryKey: ["users",query],
    queryFn: () => userService.getAll({query}),
  });
  const usersCount = useQuery({
    queryKey: ["users"],
    queryFn: () => userService.getTotalUserCount(),
  });

  return {
    usersData,
    usersCount,
    refetch: usersData.refetch,
    isLoading: usersData.isLoading
  }
};
